import { EllipsisVertical, Pencil, Trash } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import useTranslator from '@/hooks/translation'
import { Dashboard } from '@/services/fintalk/services/fintalk-backoffice/dashboards/list'

import { useDashboardEditDialog } from '../../dashboards/dialogs/edit/hooks/use-dashboard-edit-dialog'
import { useDashboardDeleteAlertDialog } from '../../dialogs/dashboard-delete/use-dashboard-delete-alert-dialog'

export function DashboardActionsPopover({
  dashboard,
}: {
  dashboard: Dashboard
}) {
  const { onOpenChange: onOpenChangeDelete } = useDashboardDeleteAlertDialog()
  const { onOpenChange: onOpenChangeEdit } = useDashboardEditDialog()

  const { getTranslation } = useTranslator()

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          size="icon"
          variant="ghost"
          className="h-6 w-6 p-0 hover:bg-transparent"
        >
          <EllipsisVertical />
        </Button>
      </PopoverTrigger>

      <PopoverContent align="start" className="w-36 p-1">
        <ul className="flex flex-col gap-1">
          <li className="w-full">
            <Button
              variant="ghost"
              className="w-full justify-start"
              onClick={() => {
                onOpenChangeEdit(true, { dashboard })
              }}
            >
              <Pencil /> {getTranslation('common.edit')}
            </Button>
          </li>

          <li className="w-full">
            <Button
              variant="ghost"
              className="group w-full justify-start text-destructive hover:text-destructive"
              onClick={() => onOpenChangeDelete(true, { dashboard })}
            >
              <Trash className="group-hover:contrast-200" />

              <span className="group-hover:contrast-200">
                {getTranslation('common.delete')}
              </span>
            </Button>
          </li>
        </ul>
      </PopoverContent>
    </Popover>
  )
}
